<cac-table
  [options]="table"
></cac-table>
